import { render, staticRenderFns } from "./MenuListItem.vue?vue&type=template&id=415a848b&scoped=true&"
import script from "./MenuListItem.vue?vue&type=script&lang=js&"
export * from "./MenuListItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuListItem.vue?vue&type=style&index=0&id=415a848b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415a848b",
  null
  
)

export default component.exports